import React, { useEffect, useState } from "react";
import { getAllNotifications, getUnreadNotifications, markAllNotificationsRead, markNotificationRead } from "../services/notificationApi";
import moment from "moment";
import { Button } from "react-bootstrap";
import LoadingSpinner from './LoadingSpinner';

const Notification = () => {
    const [notificationData, setNotificationData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchNotifications();
    }, []);

    const fetchNotifications = async () => {
        try {
            const response = await getAllNotifications();
            if (response?.data) {
                setNotificationData(response.data);
            }
        } catch (error) {
            console.error("Failed to fetch notifications", error);
        } finally {
            setLoading(false);
        }
    };

    const handleMarkAsRead = async (id) => {
        try {
            await markNotificationRead(id);
            setNotificationData((prev) =>
                prev.map((n) => (n.id === id ? { ...n, read_at: new Date().toISOString() } : n))
            );
        } catch (error) {
            console.error("Failed to mark as read", error);
        }
    };

    const handleMarkAllAsRead = async () => {
        try {
            await markAllNotificationsRead();
            setNotificationData((prev) =>
                prev.map((n) => ({ ...n, read_at: new Date().toISOString() }))
            );
        } catch (error) {
            console.error("Failed to mark all as read", error);
        }
    };

    return (
        <div className="notification-dropdown position-absolute bg-white shadow rounded p-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
                <h6 className="fw-bold mb-0">Notifications</h6>
                <Button variant="link" size="sm" className="fs-10" onClick={handleMarkAllAsRead}>
                    Mark all as read
                </Button>
            </div>
            {loading ? (
                <LoadingSpinner fullPage={false} />
            ) : (
                <ul className="list-unstyled mb-0 overflow-auto" style={{ maxHeight: 300 }}>
                    {notificationData.length === 0 && <li className="text-muted">No notifications</li>}
                    {notificationData.map((n) => (
                        <li
                            key={n.id}
                            className={`mb-2 p-2 rounded ${n.read_at ? "bg-light" : "bg-warning bg-opacity-25"}`}
                            onClick={() => handleMarkAsRead(n.id)}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="fw-6 fs-12">{n.data.title}</div>
                            <div className="text-muted fs-10">{moment(n.created_at).fromNow()}</div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default Notification;